import React, { Component } from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaMobileAlt,
  FaEnvelope,
} from "react-icons/fa";
import { Link } from "react-router-dom";

class Footer extends Component {
  render() {
    return (
      <div className="py-5 border-1 border-top border-dark">
        <div className="container">
          <div className="row">
            {/* Left Section - Logo and Description */}
            <div className="col-md-4 d-flex flex-row">
              <div className="mb-0">
                <img
                  className="img-fluid"
                  alt="company logo"
                  src="/logolgs.png"
                  width="212.82px"
                  height="36.66"
                />
                <p className="fw-bold mt-3">
                  Providing you the BEST service <br />
                  just when you need it the most.
                </p>
              </div>
            </div>

            {/* Middle Section - Contact Info */}
            <div className="col-md-6">
              <h4 className="fw-bold" style={{ color: "#303030" }}>
                CONTACT{" "}
                <span style={{ color: "#D18237" }}>
                  <i>US</i>
                </span>
              </h4>
              <p style={{ fontSize: "15px" }}>
                <FaMapMarkerAlt className="me-2" style={{ color: "#D18237" }} />
                LGS Centre, 1639 Dian corner, Rockefeller St. Brgy. San Isidro,
                Makati City
              </p>
              <p style={{ fontSize: "15px" }}>
                <FaPhone className="me-1" style={{ color: "#D18237" }} /> +63 2
                8889-2680
              </p>
              {/* <p style={{ fontSize: "15px" }}>
                <FaMobileAlt className="me-1" style={{ color: "#D18237" }} />{" "}
                +63 917-837-7772
              </p> */}
              <p style={{ fontSize: "15px" }}>
                <FaEnvelope className="me-1" style={{ color: "#D18237" }} />{" "}
                lgs.staff.hr@gmail.com
                <br />
                <p style={{ marginLeft: "23px" }}>lgs.staff.hr1@gmail.com</p>
              </p>
            </div>

            {/* Right Section - Actions */}
            <div className="col-md-2 mt-2">
              <h4 className="fw-bold" style={{ fontSize: "17px" }}>
                Actions
              </h4>
              <ul className="list-unstyled mt-4 d-flex flex-column gap-2">
                <li>
                  <a href="#" className="text-dark text-decoration-none">
                    <Link to="/">Home</Link>
                  </a>
                </li>
                <li>
                  <a href="#" className="text-dark text-decoration-none">
                    <Link to="/aboutus">About Us</Link>
                  </a>
                </li>
                {/* <li>
                  <a href="#" className="text-dark text-decoration-none">
                    <Link to="/clientpage">Clients</Link>
                  </a>
                </li>
                <li>
                  <a href="#" className="text-dark text-decoration-none">
                    <Link to="/jobportal">Job Portal</Link>
                  </a>
                </li> */}
                <li>
                  <a href="#" className="text-dark text-decoration-none">
                    <Link to="/contact">Contact Us</Link>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Footer;
